import * as React from 'react';
import classNames from 'classnames';
import type {ActionEditProps, UiDeviceAction, UiEmailAction} from '../../../modules/ruleengine/types';
import {ACTION_TYPE_DEVICE, ACTION_TYPE_EMAIL} from '../../../modules/ruleengine/config/consts';
import RuleActionEmail from './RuleActionEmail';
import RuleActionDevice from './RuleActionDevice';
import DeleteButton from '../../common/DeleteButton';
export default class RuleActionEdit extends React.PureComponent<ActionEditProps> {
	renderEmailAction = (action: UiEmailAction) => {
		const {index, onChange, emailTemplates, canEdit, canReadNotificationTemplates} = this.props;
		return (
			<RuleActionEmail
				index={index}
				onChange={onChange}
				emailTemplates={emailTemplates}
				action={action}
				canEdit={canEdit}
				canReadNotificationTemplates={canReadNotificationTemplates}
			/>
		);
	};
	renderDeviceAction = (action: UiDeviceAction) => {
		const {index, onChange, assetGroup, canEdit} = this.props;
		return (
			<RuleActionDevice
				index={index}
				onChange={onChange}
				action={action}
				assetGroup={assetGroup}
				canEdit={canEdit}
			/>
		);
	};
	renderContent = () => {
		const {action} = this.props;

		switch (action.actionType) {
			case ACTION_TYPE_EMAIL:
				return this.renderEmailAction(action);

			case ACTION_TYPE_DEVICE:
				return this.renderDeviceAction(action);

			default:
				throw new Error('unknown action type');
		}
	};

	render() {
		const {action, onRemove, index, canEdit} = this.props;
		const {
			metadata: {isValid}
		} = action;
		const actionClass = classNames({
			rule_action_edit: true,
			valid: isValid
		});
		return (
			<div className={actionClass} data-testid="single-action">
				{this.renderContent()}
				{canEdit && (
					<div className="action-functions">
						<DeleteButton onClick={() => onRemove(index)} data-testid="remove-action-button" />
					</div>
				)}
			</div>
		);
	}
}
